import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface IdTooltipCellProps {
  params: string | number;
}

const IdTooltipCell: React.FC<IdTooltipCellProps> = (props) => {
  const value = String(props.params ?? '');

  if (!value) {
    return <span>-</span>;
  }

  return (
    <Tooltip arrow placement="top" title={value}>
      <span className="block max-w-[140px] truncate">{value}</span>
    </Tooltip>
  );
};

export default IdTooltipCell;
